import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Events as MPEvents } from '../../infrastructure/mixpanel';
import Back from '../components/Back';
import Header from '../components/Header';
import ScrolledContent from '../container/ScrolledContent';
import { Redirect } from 'react-router-dom';
import * as routes from '../../infrastructure/routemap';
import { SessionConsumer } from '../components/SessionProvider';

const styles = {};

class Console extends Component {
    state = {
        redirect: undefined,
    }

    getSections = (roles) => {
        return [
            {
                name: 'Home',
                label: 'Keys',
                actionHandler: (event) => this.setState({ redirect: routes.console.keys, selected: 0 }),
                event: MPEvents.CONSOLE_KEYS,
                route: routes.console.keys
            },
            {
                name: 'Requests',
                label: 'Requests',
                actionHandler: (event) => this.setState({ redirect: routes.console.requests, selected: 1 }),
                event: MPEvents.CONSOLE_ACTIVITY,
                route: routes.console.requests
            },
            ...roles.indexOf('admin') > -1 ?
                [
                    {
                        name: 'Users',
                        label: 'Users',
                        actionHandler: (event) => this.setState({ redirect: routes.console.users, selected: 2 }),
                        event: MPEvents.CONSOLE_USERS,
                        roles: ['admin'],
                        route: routes.console.users
                    }] : []

        ];
    }

    findIndex = (name, sections) => {
        for (let i = 0; i < sections.length; i++) {
            if (sections[i].name === name) {
                return i;
            }
        }
        return undefined;
    }

    findIndex = (name, sections) => {
        for (let i = 0; i < sections.length; i++) {
            if (name === sections[i].label) {
                return i;
            };
        }
        return undefined;

    }

    render() {
        const { execution, keyId, back, children, section } = this.props;
        const { redirect } = this.state;
        return (
            <SessionConsumer>
                {({ user, ready, loggedIn }) => {
                    const sections = this.getSections(user.roles);
                    return (
                        <React.Fragment>
                            {this.state.redirect !== undefined && <Redirect to={redirect} />}
                            <Header
                                execution={execution}
                                keyId={keyId}
                                tab={this.findIndex(section, sections)}
                                sections={sections}
                                help
                                helpCallback={() => window.open(routes.extenal.docs)}
                            />
                            {back !== undefined && <Back to={back} />}
                            <ScrolledContent>
                                {children}
                            </ScrolledContent>
                        </React.Fragment>);
                }}
            </SessionConsumer>
        );
    }
}

export default withStyles(styles)(Console);